export default class BackofficeMoesIndex {
  constructor() {
    //this.bindEvents();
  }

  onDataChanged(data) {
  }

  onDestroy() {
  }
}
